import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";
import { useContext } from "react";
import { TimezoneContext } from "./TimezoneContext";

dayjs.extend(utc);
dayjs.extend(timezonePlugin);

export const useTimezoneDate = () => {
  const { timezone } = useContext(TimezoneContext);

  const formatDate = (date, format = "YYYY-MM-DD HH:mm:ss") => {
    const tz =
      typeof timezone === "object" && timezone?.value
        ? timezone.value
        : timezone || "UTC";

    try {
      return dayjs(date).tz(tz).format(format);
    } catch (err) {
      console.error("Invalid timezone:", tz, err);
      return dayjs(date).format(format); 
    }
  };

  return { formatDate, timezone };
};
